import Speaker from 'components/CategoryNav/icons/Speaker.png';
import React from 'react';
import styled from 'styled-components';
import TetDecorationDesktopSvg from './tetNotiDesktop.svg';
import TetDecorationMobileSvg from './tetNotiMobile.svg';

const NotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 10px;
  border-radius: 6px;
  background: #fffae9;
  font-size: 14px;
  margin-bottom: 0px;
  margin-top: 12px;
  font-weight: 400;
  border: 1px solid #ffe68d;
  justify-content: space-between;
  @media (max-width: 1024px) {
    width: 93%;
    margin: 0 auto 24px;
    padding: 5px 0px 5px 10px;
  }
`;

const NotificationLeftContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const DesktopSvg = styled.img`
  flex-shrink: 0;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileSvg = styled.img`
  display: none;
  flex-shrink: 0;
  @media (max-width: 1024px) {
    display: block;
  }
`;

interface HolidayNotificationProps {
  region: string;
}

const HolidayNotification = ({ region }: HolidayNotificationProps) => {
  const lang = localStorage.getItem('lang') || 'vi';

  return (
    <NotificationWrapper>
      <NotificationLeftContent>
        <img src={Speaker} style={{ width: '22px' }} />

        {lang === 'vi' ? (
          <span>
            {region === 'HN' ? (
              <>
                <span style={{ fontWeight: 500 }}>Thông báo lịch nghỉ Tết & giao hàng tại Hà Nội:</span> Nghỉ Tết từ 16
                - 20/02/2026, giao lại từ 21/02/2026.
              </>
            ) : (
              <>
                <span style={{ fontWeight: 500 }}>Thông báo lịch nghỉ Tết & giao hàng tại TP. Hồ Chí Minh:</span> Nghỉ
                Tết từ 16 - 17/02/2026, giao lại từ 18/02/2026.
              </>
            )}
          </span>
        ) : (
          <span>
            {region === 'HN' ? (
              <>
                <span style={{ fontWeight: 500 }}>Holiday & Delivery Notice in Hanoi:</span> Closed Feb 16 – 20, 2026.
                Deliveries resume Feb 21, 2026.
              </>
            ) : (
              <>
                <span style={{ fontWeight: 500 }}>Holiday & Delivery Notice in Ho Chi Minh City:</span> Closed Feb 16 –
                17, 2026. Deliveries resume Feb 18, 2026.
              </>
            )}
          </span>
        )}
      </NotificationLeftContent>
      <DesktopSvg src={TetDecorationDesktopSvg} width="109" height="38" alt="" />
      <MobileSvg src={TetDecorationMobileSvg} width="66" height="51" alt="" />
    </NotificationWrapper>
  );
};

export default HolidayNotification;
